<div class="main-container">
  <div class="left-section">
    <app-playground-slider
      (taxonomySelected)="onTaxonomySelected($event)"
      (testSelected)="onTestSelected($event)"
      (testCreated)="onTestCreated($event)">
    </app-playground-slider>
  </div>
  <div class="right-section">
    <!-- Show initial component when no test is selected or no-tests is selected -->
    <app-playground-initial *ngIf="currentView() === 'initial'"></app-playground-initial>

    <!-- Show process component when test is in progress -->
    <app-playground-process *ngIf="currentView() === 'process'"></app-playground-process>

    <!-- Show in-queued component when test is in queue -->
    <app-playground-in-queued *ngIf="currentView() === 'in-queued'"></app-playground-in-queued>

    <!-- Show loading state when fetching test results -->
    <loading *ngIf="currentView() === 'container' && isLoadingTestResults()"></loading>

    <!-- Show container component when test is processed and data is loaded -->
    <app-playground-container *ngIf="currentView() === 'container' && !isLoadingTestResults()" [testResultData]="testResultData()"></app-playground-container>
  </div>
</div>
